import { apiRequest} from './index'

export const createProjectRequest = (project) => {
  return apiRequest(
    `/admin/projects`,
    {
      method: 'POST',
      body: JSON.stringify(project)
    },
    true
  )
}

export const getProjectsRequest = (filters) => {
  const {
    page=0,
    limit=0,
    search=''
  } = filters;
  
  return apiRequest(
    `/admin/projects?page=${page}&limit=${limit}&search=${search}`,
    {
      method: 'GET'
    },
    true
  )
};

export const getProjectRequest = (id) => {
  return apiRequest(
    `/admin/projects/${id}`,
    {
      method: 'GET'
    },
    true
  )
};

export const updateProjectRequest = (project) => {
  return apiRequest(
    `/admin/projects/${project._id}`,
    {
			method: 'PUT',
			body: JSON.stringify(project)
    },
    true
  )
}

export const deleteProjectRequest = (id) => {
  return apiRequest(
    `/admin/projects/${id}`,
    {
			method: 'DELETE'
    },
    true
  )
}